import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

// Async thunk for handleActionClick API
export const handleActionClick = createAsyncThunk(
  "searchBar/handleActionClick",
  async (form, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        "message/addPhoneMessageClick",
        form
      );
      if (response.data.statusCode === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data.msg);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Error Posting my service");
    }
  }
);

// Async thunk for checkExisting API
export const checkExisting = createAsyncThunk(
  "searchBar/checkExisting",
  async (form, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post("need/checkNeedExists", form);
      if (response.data.statusCode === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data.msg);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Error checking need existence");
    }
  }
);

const initialState = {
  searchPopUp: false,
  newEmail: "",
  sampleAd: null,
  actionType: null,
  isChatModalOpen: false,
  isListNeeds: false,
  selectedNeed: null,
  actionClickStatus: "idle", // Status for handleActionClick: 'idle', 'loading', 'succeeded', 'failed'
  actionClickError: null, // Error for handleActionClick
  checkExistingStatus: "idle", // Status for checkExisting: 'idle', 'loading', 'succeeded', 'failed'
  checkExistingError: null, // Error for checkExisting
  vTName: "",
  vTNumber: null,
  isZoomStarted: false,
  link: null,
  answers: {},
  generatedNeedId: null,
  showCallDialog: false,
};

const SearchBarSlice = createSlice({
  name: "SearchBar",
  initialState,
  reducers: {
    setSearchPopUp: (state, action) => {
      state.searchPopUp = action.payload;
    },

    setNewEmail: (state, action) => {
      state.newEmail = action.payload;
    },
    setSampleAd: (state, action) => {
      state.sampleAd = action.payload;
    },
    setActionType: (state, action) => {
      state.actionType = action.payload;
    },

    setIsChatModalOpen: (state, action) => {
      state.isChatModalOpen = action.payload;
    },
    setIsListNeeds: (state, action) => {
      state.isListNeeds = action.payload;
    },
    setSelectedNeed: (state, action) => {
      state.selectedNeed = action.payload;
    },
    setVTName: (state, action) => {
      state.vTName = action.payload;
    },
    setVTNumber: (state, action) => {
      state.vTNumber = action.payload;
    },
    setIsZoomStarted: (state, action) => {
      state.isZoomStarted = action.payload;
    },
    setLink: (state, action) => {
      state.link = action.payload;
    },
    setAnswers: (state, action) => {
      state.answers = action.payload;
    },
    setGeneratedNeedId: (state, action) => {
      state.generatedNeedId = action.payload;
    },
    setShowCallDialog: (state, action) => {
      state.showCallDialog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleActionClick.pending, (state) => {
        state.actionClickStatus = "loading";
        state.actionClickError = null;
      })
      .addCase(handleActionClick.fulfilled, (state) => {
        state.actionClickStatus = "succeeded";
      })
      .addCase(handleActionClick.rejected, (state, action) => {
        state.actionClickStatus = "failed";
        state.actionClickError = action.payload;
      })
      .addCase(checkExisting.pending, (state) => {
        state.checkExistingStatus = "loading";
        state.checkExistingError = null;
      })
      .addCase(checkExisting.fulfilled, (state) => {
        state.checkExistingStatus = "succeeded";
      })
      .addCase(checkExisting.rejected, (state, action) => {
        state.checkExistingStatus = "failed";
        state.checkExistingError = action.payload;
      });
  },
});

export const {
  setSearchPopUp,
  setNewEmail,
  setSampleAd,
  setActionType,
  setIsChatModalOpen,
  setIsListNeeds,
  setSelectedNeed,
  setVTName,
  setVTNumber,
  setIsZoomStarted,
  setLink,
  setAnswers,
  setGeneratedNeedId,
  setShowCallDialog,
} = SearchBarSlice.actions;

export default SearchBarSlice.reducer;
